export const FloatLabel = (() => {
	const handleFocus = (e) => {
		const target = e.target;
		target.parentNode.parentNode.classList.add("label-is-floating");
	};

	const handleBlur = (e) => {
		const target = e.target;
		if (!target.value) {
			target.parentNode.parentNode.classList.remove("label-is-floating");
		}
	};

	const bindEvents = (element) => {
		const floatField = element.querySelector("input, textarea, select");

		if (!floatField) {
			console.warn("Aucun champ trouvé dans", element);
			return;
		}

		floatField.addEventListener("focus", handleFocus);
		floatField.addEventListener("blur", handleBlur);
	};

	const init = () => {
		const containerSelector = ".field_sublabel_below, .searchform";
		const excludeSelectors = [".gfield--type-section", ".gfield--input-type-fileupload"];

		const floatContainers = document.querySelectorAll(`${containerSelector}:not(${excludeSelectors.join(", ")})`);

		floatContainers.forEach((element) => {
			const input = element.querySelector("input") || element.querySelector("textarea");

			if (input && input.value) {
				element.classList.add("label-is-floating");
			}

			bindEvents(element);
		});
	};

	return {
		init: init,
	};
})();
